"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABS_TRIGGER_TYPE = exports.TABS_DISPLAY_TYPE = void 0;
var TABS_TRIGGER_TYPE = /*#__PURE__*/function (TABS_TRIGGER_TYPE) {
  TABS_TRIGGER_TYPE["hover"] = "hover";
  TABS_TRIGGER_TYPE["hoverDelayed"] = "hoverDelayed";
  TABS_TRIGGER_TYPE["click"] = "click";
  TABS_TRIGGER_TYPE["none"] = "none";
  return TABS_TRIGGER_TYPE;
}({});
exports.TABS_TRIGGER_TYPE = TABS_TRIGGER_TYPE;
var TABS_DISPLAY_TYPE = /*#__PURE__*/function (TABS_DISPLAY_TYPE) {
  TABS_DISPLAY_TYPE["horizontal"] = "horizontal";
  TABS_DISPLAY_TYPE["vertical"] = "vertical";
  return TABS_DISPLAY_TYPE;
}({});
exports.TABS_DISPLAY_TYPE = TABS_DISPLAY_TYPE;